<template>
    <div class="main">
        <HeaderBlock></HeaderBlock>
        <div class="container-fluid h-100">
            <div class="row main-row" :class="{'sidebar-hidden' : sidebarHidden}">
                <div class="col sidebar bg-dark p-0" v-show="!sidebarHidden">
                    <SideBar></SideBar>
                </div>
                <div class="col">
                    <div class="main-content p-3 m-2 rounded">
                        <notifications></notifications>
                        <v-dialog/>
                        <router-view></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderBlock from '../../components/HeaderBlock.vue'
import SideBar from '../../components/SideBar.vue'

export default {
  name: 'AddAgentIndex',
  components: {
    HeaderBlock,
    SideBar
  },
  computed: {
    sidebarHidden () {
      return this.$store.state.appSettings.sidebarHidden
    }
  }
}

</script>

<style lang="scss">
.sidebar {
  height: calc(100% - 50px);
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--thumbBG) var(--scrollbarBG);

  &::-webkit-scrollbar {
    width: 11px;
  }

  &::-webkit-scrollbar-track {
    background: var(--scrollbarBG);
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--thumbBG) ;
    border-radius: 6px;
    border: 3px solid var(--scrollbarBG);
  }

}
</style>
